import { STRING_MIN_LENGTH_DEFAULT } from '@cbridge-utils/app';
import { NetworkStatus } from '@cbridge-utils/network';
import { INodeStore } from './node.interface';

export const NODE_NAME_MIN_LENGTH = STRING_MIN_LENGTH_DEFAULT;
export const NODE_NAME_MAX_LENGTH = 128;

export const nodeInitialState: INodeStore = {
  list: [],
  networkStatus: NetworkStatus.None,
};
